"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Input = require("./Input.styles");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox2 = require("../../Layout/OffsetBox/useOffsetBox");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _DropList = require("./partials/DropList");
var _Card = require("../Card");
var _Icon = require("../Icon");
var _Button = require("../Button");
var _Portal = require("../../Layout/Portal");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Input = /*#__PURE__*/_react.default.forwardRef(function (props, outerRef) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    direction = _useContext.direction;
  var _ref = props,
    _ref$dir = _ref.dir,
    dir = _ref$dir === void 0 ? direction : _ref$dir,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position,
    placeholder = _ref.placeholder,
    maxLength = _ref.maxLength,
    isWithClearButton = _ref.isWithClearButton,
    onClearButtonClick = _ref.onClearButtonClick,
    _ref$isAttachedToWind = _ref.isAttachedToWindow,
    isAttachedToWindow = _ref$isAttachedToWind === void 0 ? isMobileView : _ref$isAttachedToWind,
    _ref$isFullScreen = _ref.isFullScreen,
    isFullScreen = _ref$isFullScreen === void 0 ? false : _ref$isFullScreen,
    _ref$isOpenOnFocus = _ref.isOpenOnFocus,
    isOpenOnFocus = _ref$isOpenOnFocus === void 0 ? false : _ref$isOpenOnFocus,
    _ref$autoCompleteOpti = _ref.autoCompleteOptions,
    autoCompleteOptions = _ref$autoCompleteOpti === void 0 ? [] : _ref$autoCompleteOpti,
    onAutoCompleteSelect = _ref.onAutoCompleteSelect;
  var _ref2 = props,
    min = _ref2.min,
    max = _ref2.max,
    step = _ref2.step;
  var _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    id = props.id,
    ariaLabel = props.ariaLabel,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    onChange = props.onChange,
    width = props.width;
  var _useOffsetBox = (0, _useOffsetBox2.useOffsetBox)(isOpenOnFocus),
    dropContentRef = _useOffsetBox.dropContentRef,
    handleAnchorFocus = _useOffsetBox.handleAnchorFocus,
    handleAnchorKeyUp = _useOffsetBox.handleAnchorKeyUp,
    isOpen = _useOffsetBox.isOpen,
    open = _useOffsetBox.open,
    close = _useOffsetBox.close;
  var _useState = (0, _react.useState)(position),
    _useState2 = _slicedToArray(_useState, 2),
    actualBoxPosition = _useState2[0],
    setActualBoxPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var getValueAsPercentage = (0, _react.useCallback)(function (val) {
    return (val - min) * 100 / (max - min);
  }, [max, min]);
  var inputValueAsPercentage = type === 'range' ? getValueAsPercentage(Number(inputValue)) : 0;
  var styles = (0, _Input.useStyles)(props, isOpen, inputValueAsPercentage);
  var handleBoxPositionChange = function handleBoxPositionChange(pos) {
    setActualBoxPosition(pos);
  };
  var handleChange = function handleChange(event) {
    setInputValue(event.currentTarget.value);
    if (onChange) {
      onChange(event.currentTarget.value);
    }
  };
  var handleAutoCompleteSelect = function handleAutoCompleteSelect(option) {
    close();
    setInputValue(option.label);
    if (onAutoCompleteSelect) {
      onAutoCompleteSelect(option);
    }
  };
  var handleClearBtnClick = function handleClearBtnClick() {
    if (onClearButtonClick) {
      onClearButtonClick();
    }
  };
  (0, _react.useEffect)(function () {
    if (autoCompleteOptions !== null && autoCompleteOptions !== void 0 && autoCompleteOptions.length) {
      open();
    } else {
      close();
    }
  }, [autoCompleteOptions, close, open]);
  (0, _react.useEffect)(function () {
    setInputValue(value);
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Input-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Input'],
      "data-testid": id,
      children: type === 'range' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: type,
        className: styles['cc-Input__field'],
        value: inputValue,
        onChange: handleChange,
        min: min,
        max: max,
        step: step,
        "aria-label": ariaLabel
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        position: position,
        isOpen: isOpen,
        anchorWidth: "auto",
        onBoxPositionChange: handleBoxPositionChange,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: styles['cc-Input__content'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            "data-testid": id ? "input-".concat(id) : null,
            type: type,
            className: styles['cc-Input__field'],
            placeholder: placeholder,
            maxLength: maxLength,
            dir: dir,
            value: inputValue,
            onChange: handleChange,
            onKeyUp: handleAnchorKeyUp,
            onFocus: handleAnchorFocus,
            "aria-label": ariaLabel,
            ref: outerRef
          }), isWithClearButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: styles['cc-Input__clear-btn'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              id: "ccInputCloseButton",
              view: "link",
              color: "basic",
              onClick: handleClearBtnClick,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: "Close",
                width: 10,
                height: 10
              })
            })
          })]
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          ref: dropContentRef,
          position: actualBoxPosition,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: width,
          onClose: close,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropList.DropList, {
              options: autoCompleteOptions,
              isFullScreen: isFullScreen,
              onInputOptionSelect: handleAutoCompleteSelect
            })
          })
        })
      })
    })]
  });
});
exports.Input = Input;